import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [['How do I receive the material?', 'Right after purchase, you will receive an email with direct links to download all the digital files.'], ['Does this work if I’m a beginner teacher?', 'Absolutely. Every volume is structured with clear guidance, practical activities, and confidence-building resources.'], ['What grade levels does this cover?', 'The Art Ready Pack includes 5 Elementary Volumes and 5 Secondary Volumes with clear progression by level.'], ['Are the bonuses included in the price?', 'Yes. All five exclusive bonuses are included free with your Art Ready Pack purchase.'], ['What file format are the volumes in?', 'Everything is delivered as high-quality PDF files, optimised for reading, printing, and classroom use.'], ['Do I have to pay monthly?', 'No. This is a one-time payment with lifetime access to the complete pack.'], ['What if I don’t like it?', 'You have 7 days to decide. If it is not what you expected, simply email us for a no-questions-asked refund.']];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-248">
      <Reveal className="mx-auto max-w-3xl" data-id="element-249">
        <h2 className="mb-12 text-center text-3xl font-black md:text-4xl" data-id="element-250">
          Frequently Asked Questions
        </h2>
        <div className="space-y-3" data-id="element-251">
          {faqs.map(([question, answer], index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-black/[0.04] bg-brand-alt" data-id="element-252">
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-red" data-id="element-253">
                  <span data-id="element-254">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-red" aria-hidden="true" data-id="element-255" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-red" aria-hidden="true" data-id="element-256" />}
                </button>
                <AnimatePresence initial={false} data-id="element-257">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-258">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-259">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}